module.exports = __webpack_public_path__ + "static/img/sm_11.b0a5f29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_11.png
// module id = S5F6
// module chunks = 0